import { Observable } from 'rxjs';

export interface AuthClaims {
  // Registered standard JWT claims
  sub: string; // Subject (typically the user ID)
  email: string; // User's email address
  iss: string; // Issuer of the token
  aud: string; // Audience (who the token is intended for)
  iat: number; // Issued At (timestamp)
  exp: number; // Expiration time (timestamp)

  // 4Next custom claims
  name: string;
}

export abstract class AuthenticationService {
  redirectUrl = '';
  abstract postLogoutRedirectUri?: string;
  abstract getToken(): string;
  abstract getApiToken(): Observable<string>;
  abstract getDecodedToken(): string | null;
  abstract getIdentityClaims(): AuthClaims;
  abstract login(requestedUrl?: string, tenantCode?: string): void;
  abstract handleLoginRedirect(): Promise<boolean>;
  abstract isLoggedIn(): Observable<boolean>;
  abstract logOut(): void;
  abstract hasValidAccessToken(): boolean;
  abstract logOutUrl(): string;
}
